import React, { useState } from 'react';
import logo from './logo.svg';
import './App.css';
import DevTicketPage from './pages/DevTicketPage';
import ProdTicketPage from './pages/ProdTicketPage';

function App() {
  const mode = process.env.REACT_APP_TICKET_MODE || 'prod';
  const [success, setSuccess] = useState(false);

  const handleSuccess = () => {
    setSuccess(true);
    setTimeout(() => setSuccess(false), 3000);
  };

  return (
    <div className="App" style={{ background: '#fff', minHeight: '100vh' }}>
      <header style={{ background: 'none', minHeight: 'unset', color: '#222', padding: '2rem 0' }}>
        <div style={{ maxWidth: '70%', margin: '0 auto' }}>
          {mode === 'dev' ? (
            <DevTicketPage onSuccess={handleSuccess} />
          ) : (
            <ProdTicketPage onSuccess={handleSuccess} />
          )}
        </div>
        {success && <div className="success-message">Successfully submitted!</div>}
      </header>
    </div>
  );
}

export default App;
